
const digest = '9f60d721a5fee66a5c42f501f59a71f4b567f1b4536c27060c0ecd837856910d';
const classes = {"wrapper":"_wrapper_115bk_1"};
const css = `._wrapper_115bk_1 {
  padding: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  